export default "https://cdn-static-staging.gokick.com/assets/44c43e25e1d60214daaa18ce4b143b941a81a79a/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";